import React from "react";
import classNames from "classnames";
import styles from "./answerContainer.module.scss";
import FileLink from "./FileLink";
import { ImagePreview } from "./ImagePreview";
import { IFile, IImage, IMessage, IShareChatMessage, ISharImgeChat } from "redux/actions";

interface CombinedFilesImagesContainerProps {
  message?: IMessage;
  shareMessage?: IShareChatMessage;
  shareChat?: boolean;
  isShareChat: boolean;
  threads?: boolean;
  loading: boolean;
  handleImageLoad: () => void;
}

const CombinedFilesImagesContainer: React.FC<CombinedFilesImagesContainerProps> = ({
  message,
  shareMessage,
  shareChat,
  threads,
  loading,
  handleImageLoad,
}) => {
  // Get files and images from either message or shareMessage
  const files: IFile[] = message?.files || shareMessage?.files || [];
  const images: (IImage | ISharImgeChat)[] = message?.images || shareMessage?.images || [];

  if (files.length === 0 && images.length === 0) {
    return null;
  }
  return (
    <div className={classNames(styles.uploadsContainer, {
      // [styles.threads]: threads,
    })}>
      {/* Container for all attachments */}
      <div className={styles.singleRowContainer}>
        {/* Files Section */}
        {files.length > 0 && (
          <div className={classNames(styles.filesSection, {
            [styles.sharedContainer]: (shareMessage?.files?.length ?? 0) > 0 && shareMessage?.content
          })}>
            <FileLink
              file={files}
              contentFile={true}
              combinedFile={true}
              messageId={message?.id ?? 1}
              threads={threads}
              inlineDisplay={images.length > 0} // Pass prop to indicate inline display
            />
          </div>
        )}

        {/* Images Section */}
        {images.length > 0 && (
          <div className={classNames(styles.combinedImagesContainer, styles.additionalimages, {
            [styles.imageContent]: true,
            [styles.sharedimageContainer]: (message?.images?.length ?? 0) > 0 && !shareChat,
          })}>
            <ImagePreview
            combinedFile={true}
              images={images}
              threads={threads}
              loading={loading}
              handleImageLoad={handleImageLoad}
              inlineDisplay={files.length > 0} // Pass prop to indicate inline display
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CombinedFilesImagesContainer;